import './page/suggestion-list';

Shopware.Module.register('topdata-es-suggestion', {
    type: 'plugin',
    name: 'SearchSuggestions',
    title: 'TopdataEnhancedSearchSW6.topdata-es-suggestion.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-suggestion.description',
    color: '#37d6b5',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-suggestion-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-suggestion',
        parent: 'topdata-es',
        label: 'TopdataEnhancedSearchSW6.topdata-es-suggestion.title',
        path: 'topdata.es.suggestion.list',
        icon: 'default-shopping-search',
        privilege: 'system.zero_search.viewer',
    }],
});
